<template>
  <div class="layout_header">
    <h1 class="text_size_16 text_bold text_color_active title">{{ projectInfo.name }}</h1>
    <header-avatar />
  </div>
</template>

<script>
import headerAvatar from './header-avatar'
import * as api from '~/api'
export default {
  data () {
    return {
      projectInfo: {
        name: ''
      }
    }
  },
  components: {
    headerAvatar
  },
  created () {
    this.getProjectInfo()
  },
  methods: {
    // 获取课题信息
    getProjectInfo () {
      api.getProjectInfo().then(res => {
        if (res.data.code === 0) {
          console.log('顶部获取课题信息', res.data.data.project)
          this.projectInfo = res.data.data.project
          // 设置项目信息
          this.$store.commit('SET_PROJECT_INFO', res.data.data.project)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: $layout-header-height;
  background-color: $color-white;
  box-shadow:0px 0px 4px rgba(0,0,0,0.16);
  z-index: 100;
  .title {
    padding-left: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/container/header/index.vue